module.exports = __webpack_public_path__ + "img/SUB.0edb92c3.png";